(ns app.tiktok-posting.register
  "UI register entries for the TikTok posting slice."
  (:require [app.tiktok-posting.page :as page]))

(def register
  [page/page])
